import { createReducer, on } from '@ngrx/store';
import { VideoSearchActions } from './video-search.actions';
import { initialVideoSearchState, VideoSearchResult, VideoSearchState } from './models/video-search.models';

export const videoSearchReducer = createReducer(
  initialVideoSearchState,

  on(VideoSearchActions.handleSearchResults, (state, { payload }): VideoSearchState => {
    // Extract all results from all searches
    const allResults: VideoSearchResult[] = [];
    payload.video_searches.forEach(search => {
      allResults.push(...search.results);
    });

    return {
      ...state,
      searchResults: allResults,
      // Show link if we have results
      isLinkVisible: allResults.length > 0
    };
  }),

  on(VideoSearchActions.showLink, (state): VideoSearchState => ({
    ...state,
    isLinkVisible: true
  })),

  on(VideoSearchActions.showLinkAfterSpeech, (state): VideoSearchState => ({
    ...state,
    isLinkVisible: true
  })),

  on(VideoSearchActions.hideLink, (state): VideoSearchState => ({
    ...state,
    isLinkVisible: false
  })),

  on(VideoSearchActions.clearResults, (): VideoSearchState => ({
    ...initialVideoSearchState
  }))
);
